"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonationErrorResponseSchema = exports.ImpersonationError = exports.ImpersonationErrorCode = exports.ImpersonationUserDtoSchema = exports.ImpersonateUserResponseSchema = exports.ImpersonateUserRequestSchema = void 0;
const zod_1 = require("zod");
const organization_1 = require("./organization");
/**
 * LOCAL & DEV only. An admin submits the target user's externalAuthId (Clerk's
 * own user id — see `ImpersonationUserDto` below); the backend mints a Clerk
 * actor token and returns the raw `token`. The caller signs the admin out,
 * then redeems the ticket itself in whichever app should receive the
 * impersonated session (e.g. `apps/mobile` for a Driver, `customer-admin-portal`
 * for a CompanyAdmin) — Clerk's hosted `url` field is deliberately unused here
 * since it can't be steered to a specific app.
 */
exports.ImpersonateUserRequestSchema = zod_1.z.object({
    externalAuthId: zod_1.z.string(),
});
exports.ImpersonateUserResponseSchema = zod_1.z.object({
    token: zod_1.z.string(),
    expiresInSeconds: zod_1.z.number(),
});
/**
 * `OrganizationUserDto` plus Clerk's own user id. Admin-only — lets the
 * Impersonate page's user picker send `externalAuthId` directly instead of
 * requiring a second DB lookup by email on the backend.
 */
exports.ImpersonationUserDtoSchema = organization_1.OrganizationUserDtoSchema.omit({
    usedBookingsThisMonth: true,
}).extend({
    externalAuthId: zod_1.z.string().nullable(),
});
var ImpersonationErrorCode;
(function (ImpersonationErrorCode) {
    ImpersonationErrorCode["FeatureDisabled"] = "FEATURE_DISABLED";
    ImpersonationErrorCode["UserNotFound"] = "USER_NOT_FOUND";
    ImpersonationErrorCode["ClerkUserMissing"] = "CLERK_USER_MISSING";
    ImpersonationErrorCode["TokenCreationFailed"] = "TOKEN_CREATION_FAILED";
    ImpersonationErrorCode["Unknown"] = "UNKNOWN";
})(ImpersonationErrorCode || (exports.ImpersonationErrorCode = ImpersonationErrorCode = {}));
class ImpersonationError extends Error {
    constructor(message, errorCode) {
        super(message);
        this.errorCode = errorCode;
        this.name = 'ImpersonationError';
    }
}
exports.ImpersonationError = ImpersonationError;
/** Error body returned by `/impersonateUser` on failure. */
exports.ImpersonationErrorResponseSchema = zod_1.z.object({
    error: zod_1.z.string(),
    errorCode: zod_1.z.nativeEnum(ImpersonationErrorCode).optional(),
});
//# sourceMappingURL=impersonation.js.map